import { imputationTypeEnum } from './dataStatus';

export const mapperPosLineArray = (pLArray) => {
  const posiciones = [];
  const lineas = [];

  pLArray?.forEach(({ position, line }) => {
    if (position) {
      posiciones.push({ id: position.id, posicion: position.numeroPosicion });
    }
    if (line) {
      lineas.push({ id: line.id, linea: line.numeroLinea });
    }
  });

  return {
    posiciones,
    lineas
  };
};

export const mapperPosition = (responsePositions) =>
  responsePositions?.map((position) => ({
    id: position.id,
    idPosicion: position.id,
    nombre: `${position.numeroPosicion} - ${position.descripcionSap}`,
    descripcionSapPosicion: position.descripcionSap,
    descripcionYClicPosicion: position.descripcionYClick,
    numeroPosicion: position.numeroPosicion
  }));

export const mapperLine = (responseLines) =>
  responseLines?.map((line) => ({
    id: line.id,
    idLinea: line.id,
    nombre: `${line.numeroLinea} - ${line.descripcionSap}`,
    numeroLinea: line.numeroLinea,
    unidadMedida: line.uMedida,
    unidadMedidaCert: line.uMedidaCertificacion,
    descripcionSapLinea: line.descripcionSap,
    descripcionYClicLinea: line.descripcionYClick,
    factorConversion: line.factorConversion,
    onCall: line.onCall,
    mensualizada: line.mensualizada
  }));

export const mapperLineObject = (responseLines) => ({
  id: responseLines.id,
  idLinea: responseLines.idLinea,
  nombre: `${responseLines.numeroLinea} - ${responseLines.descripcionLineaSap}`,
  numeroLinea: responseLines.numeroLinea,
  unidadMedida: responseLines.unidadMedida,
  unidadMedidaCert: responseLines.unidadMedidaCert,
  descripcionSapLinea: responseLines.descripcionLineaSap,
  descripcionYClicLinea: responseLines.descripcionLineaYClic,
  factorConversion: responseLines.factorConversion,
  onCall: responseLines.onCall,
  mensualizada: responseLines.mensualizada
});

export const mapperPositionObject = (responsePositions) => ({
  id: responsePositions.id,
  idPosicion: responsePositions.idPosicion,
  nombre: `${responsePositions.numeroPosicion} - ${responsePositions.descripcionPosicionSap}`,
  descripcionSapPosicion: responsePositions.descripcionPosicionSap,
  descripcionYClicPosicion: responsePositions.descripcionPosicionYClic,
  numeroPosicion: responsePositions.numeroPosicion
});

export const mapperAllArray = (response, isEdit) =>
  response?.map((data) => {
    const { line, position, amount } = data;

    return {
      idPosicion: position.id,
      numeroPosicion: position.numeroPosicion,
      descripcionPosicionSap: position.descripcionSapPosicion,
      descripcionPosicionYClic: position.descripcionYClicPosicion,
      idLinea: line.idLinea,
      numeroLinea: line.numeroLinea,
      unidadMedida: line.unidadMedida,
      descripcionLineaSap: line.descripcionSapLinea,
      descripcionLineaYClic: line.descripcionYClicLinea,
      onCall: line.onCall,
      mensualizada: line.mensualizada,
      cantidad: amount || null,
      positionName: `${position.numeroPosicion} - ${position.descripcionSapPosicion}`,
      lineName: `${line?.numeroLinea} - ${line?.descripcionSapLinea}`,
      idPlantillaParteTrabajoLinea: data.idPlantillaParteTrabajoLinea,
      eliminarPosicionLinea: isEdit ? false : data.eliminarPosicionLinea,
      // A las nuevas posiciones y lineas agregadas en edicion, identifico con isEdit
      isNewPosLine: isEdit
    };
  });

export const mapperAllArrayWithObjects = (response) =>
  response?.map((data) => ({
    positionValue: {
      id: data.idPosicion,
      idPosicion: data.idPosicion,
      numeroPosicion: data.numeroPosicion,
      descripcionSapPosicion: data.posicionSap,
      descripcionYClicPosicion: data.posicionYClick,
      nombre: `${data.numeroPosicion} - ${data.posicionSap}`
    },
    lineValue: {
      id: data.idLinea,
      idLinea: data.idLinea,
      numeroLinea: data.numeroLinea,
      unidadMedida: data.unidadMedida,
      descripcionSapLinea: data.lineaSap,
      descripcionYClicLinea: data.lineaYClick,
      nombre: `${data.numeroLinea} - ${data.lineaSap}`,
      onCall: data.onCall,
      mensualizada: data.mensualizada
    }
  }));

export const mapperBusinessUnit = (response) =>
  response?.map((data) => ({
    id: data.nroContrato,
    nombre: `${data.nroContrato}`,
    operationsIds: data?.idOperacion.map((operation) => operation),
    businessUnitsIds: data?.idUnidadNegocio.map((businessUnit) => businessUnit)
  }));

export const mapperImputationDefault = (response, imputationType) => ({
  logisticCenter: response?.centroLogistico,
  state: response?.estado,
  socCode: response?.sociedadCodigo,
  soc: response?.sociedadLogo,
  warningState:
    (imputationType?.id === imputationTypeEnum.PEP && response?.estado !== 'LIBE') ||
    (imputationType?.id === imputationTypeEnum.ORDEN && response?.estado !== 'LIBE') ||
    (imputationType?.id === imputationTypeEnum.CECO && response?.estado === 'BLOQUEADO'),
  description: response?.estadoDescripcion,
  alerta: response?.alerta
});

const mapperOfEvent = ({ event, eventPendingOfAssignment, well }) => {
  if (eventPendingOfAssignment) {
    return {
      sigla: event?.nombre,
      value: event?.id,
      label: event?.nombre,
      id: 0,
      nombre: event?.nombre,
      eventoPozoId: 0
    };
  }

  return {
    sigla: event ? event?.sigla : well?.evento?.sigla,
    value: event ? event?.id : well?.evento?.id,
    label: event ? event?.sigla : well?.evento?.sigla,
    id: event ? event?.id : well?.evento?.id,
    nombre: event ? event?.nombre : well?.evento?.nombre,
    eventoPozoId: well?.idEventoPozo || well?.evento?.idEventoPozo || well?.evento?.eventoPozoId
  };
};

export const mapperAccountAssignmentObject = ({
  wells = [],
  budget = [],
  event = null, // se manda solo cuando se trae detalle de borrador
  eventPendingOfAssignment, // Boolean
  mensualizada = false,
  isOyM = false,
  technicalLocation = {},
  imputationType = {},
  imputationObject = {},
  objetDetail = {}
}) => {
  if (!isOyM) {
    return wells.map((well, i) => ({
      well: {
        value: well?.pozo?.id,
        label: well?.pozo?.nombre,
        id: well?.pozo?.id,
        nombre: well?.pozo?.nombre
      },
      event: mapperOfEvent({ event, eventPendingOfAssignment, well }),
      team: {
        id: well?.equipo?.id,
        nombre: well?.equipo?.nombre,
        value: well?.equipo?.id,
        label: well?.equipo?.nombre
      },
      operationType: eventPendingOfAssignment
        ? {
            id: event?.id,
            nombre: event?.sigla,
            value: event?.id,
            label: event?.sigla
          }
        : null,
      imputationType: {
        value: well?.tipoImputacion?.id,
        label: well?.tipoImputacion?.nombre,
        id: well?.tipoImputacion?.id,
        nombre: well?.tipoImputacion?.nombre
      },
      imputationObject: {
        ...well?.objetoImputacion,
        value: well?.objetoImputacion?.id,
        label:
          (well?.objetoImputacion?.nombre || well?.objetoImputacion?.codigo) &&
          well?.objetoImputacion?.descripcion
            ? `${well?.objetoImputacion?.nombre || well?.objetoImputacion?.codigo} | ${
                well?.objetoImputacion?.descripcion
              }`
            : undefined,
        id: well?.objetoImputacion?.id,
        nombre: well?.objetoImputacion?.nombre || well?.objetoImputacion?.codigo
      },
      idRequestWell: well.idSolicitudServicioPozo,
      serviceRequestId: well.idSolicitudServicioPozo,
      idMonthlyWellServiceRequest: mensualizada ? well.idSolicitudServicioPozo : 0,
      // Detalle
      budget: budget.length ? budget[i]?.presupuesto : null,
      warningBudget:
        (well.tipoImputacion?.id === imputationTypeEnum.PEP && budget[i]?.presupuesto < 10000) ||
        false,
      eliminado: false,
      ...mapperImputationDefault(well?.detalleObjeto, well?.tipoImputacion)
    }));
  }

  return [
    {
      well: {
        id: technicalLocation?.ubicacion?.id || technicalLocation?.id,
        value: technicalLocation?.ubicacion?.id || technicalLocation?.id,
        label: technicalLocation?.ubicacion?.descripcion || technicalLocation?.descripcion,
        nombre: technicalLocation?.ubicacion?.descripcion || technicalLocation?.descripcion
      },
      event: {
        id: null,
        value: null,
        label: null,
        nombre: null
      },
      team: {
        id: null,
        value: null,
        label: null,
        nombre: null
      },
      imputationType: {
        value: technicalLocation?.tipoImputacion?.id || imputationType?.id,
        label: technicalLocation?.tipoImputacion?.nombre || imputationType?.nombre,
        id: technicalLocation?.tipoImputacion?.id || imputationType?.id,
        nombre: technicalLocation?.tipoImputacion?.nombre || imputationType?.nombre
      },
      imputationObject: {
        ...technicalLocation?.objetoImputacion,
        ...imputationObject,
        value: technicalLocation?.objetoImputacion?.id || imputationObject?.id,
        label:
          (technicalLocation?.objetoImputacion?.codigo || imputationObject?.nombre) &&
          (technicalLocation?.objetoImputacion?.descripcion || imputationObject?.descripcion)
            ? `${technicalLocation?.objetoImputacion?.codigo || imputationObject?.nombre} | ${
                technicalLocation?.objetoImputacion?.descripcion || imputationObject?.descripcion
              }`
            : undefined,
        id: technicalLocation?.objetoImputacion?.id || imputationObject?.id,
        nombre: technicalLocation?.objetoImputacion?.codigo || imputationObject?.nombre
      },
      idRequestWell: null,
      serviceRequestId: null,
      idMonthlyWellServiceRequest: 0,
      // Detalle
      budget: budget.length ? budget?.[0]?.presupuesto : null,
      warningBudget:
        (technicalLocation?.tipoImputacion?.id === imputationTypeEnum.PEP &&
          budget?.presupuesto < 10000) ||
        false,
      eliminado: false,
      ...mapperImputationDefault(
        technicalLocation?.detalleObjeto || objetDetail,
        technicalLocation?.tipoImputacion
      )
    }
  ];
};
